import { FC } from "react";

export const TraderMobileIcon: FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M1.33301 18.6668C1.33301 17.9304 1.92996 17.3335 2.66634 17.3335H5.33301C6.06939 17.3335 6.66634 17.9304 6.66634 18.6668V28.0002C6.66634 28.7365 6.06939 29.3335 5.33301 29.3335H2.66634C1.92996 29.3335 1.33301 28.7365 1.33301 28.0002V18.6668Z"
          fill="url(#paint0_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33301 18.0002H2.66634C2.29815 18.0002 1.99967 18.2986 1.99967 18.6668V28.0002C1.99967 28.3684 2.29815 28.6668 2.66634 28.6668H5.33301C5.7012 28.6668 5.99967 28.3684 5.99967 28.0002V18.6668C5.99967 18.2986 5.7012 18.0002 5.33301 18.0002ZM2.66634 17.3335C1.92996 17.3335 1.33301 17.9304 1.33301 18.6668V28.0002C1.33301 28.7365 1.92996 29.3335 2.66634 29.3335H5.33301C6.06939 29.3335 6.66634 28.7365 6.66634 28.0002V18.6668C6.66634 17.9304 6.06939 17.3335 5.33301 17.3335H2.66634Z"
          fill="url(#paint1_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          d="M9.33301 12.0001C9.33301 11.2637 9.92996 10.6667 10.6663 10.6667H13.333C14.0694 10.6667 14.6663 11.2637 14.6663 12.0001V28.0001C14.6663 28.7365 14.0694 29.3334 13.333 29.3334H10.6663C9.92996 29.3334 9.33301 28.7365 9.33301 28.0001V12.0001Z"
          fill="url(#paint2_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.333 11.3334H10.6663C10.2982 11.3334 9.99967 11.6319 9.99967 12.0001V28.0001C9.99967 28.3683 10.2982 28.6667 10.6663 28.6667H13.333C13.7012 28.6667 13.9997 28.3683 13.9997 28.0001V12.0001C13.9997 11.6319 13.7012 11.3334 13.333 11.3334ZM10.6663 10.6667C9.92996 10.6667 9.33301 11.2637 9.33301 12.0001V28.0001C9.33301 28.7365 9.92996 29.3334 10.6663 29.3334H13.333C14.0694 29.3334 14.6663 28.7365 14.6663 28.0001V12.0001C14.6663 11.2637 14.0694 10.6667 13.333 10.6667H10.6663Z"
          fill="url(#paint3_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          d="M17.333 16.0001C17.333 15.2637 17.93 14.6667 18.6663 14.6667H21.333C22.0694 14.6667 22.6663 15.2637 22.6663 16.0001V28.0001C22.6663 28.7365 22.0694 29.3334 21.333 29.3334H18.6663C17.93 29.3334 17.333 28.7365 17.333 28.0001V16.0001Z"
          fill="url(#paint4_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.333 15.3334H18.6663C18.2982 15.3334 17.9997 15.6319 17.9997 16.0001V28.0001C17.9997 28.3683 18.2982 28.6667 18.6663 28.6667H21.333C21.7012 28.6667 21.9997 28.3683 21.9997 28.0001V16.0001C21.9997 15.6319 21.7012 15.3334 21.333 15.3334ZM18.6663 14.6667C17.93 14.6667 17.333 15.2637 17.333 16.0001V28.0001C17.333 28.7365 17.93 29.3334 18.6663 29.3334H21.333C22.0694 29.3334 22.6663 28.7365 22.6663 28.0001V16.0001C22.6663 15.2637 22.0694 14.6667 21.333 14.6667H18.6663Z"
          fill="url(#paint5_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          d="M25.333 22.6668C25.333 21.9304 25.93 21.3335 26.6663 21.3335H29.333C30.0694 21.3335 30.6663 21.9304 30.6663 22.6668V28.0002C30.6663 28.7365 30.0694 29.3335 29.333 29.3335H26.6663C25.93 29.3335 25.333 28.7365 25.333 28.0002V22.6668Z"
          fill="url(#paint6_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.333 22.0002H26.6663C26.2982 22.0002 25.9997 22.2986 25.9997 22.6668V28.0002C25.9997 28.3684 26.2982 28.6668 26.6663 28.6668H29.333C29.7012 28.6668 29.9997 28.3684 29.9997 28.0002V22.6668C29.9997 22.2986 29.7012 22.0002 29.333 22.0002ZM26.6663 21.3335C25.93 21.3335 25.333 21.9304 25.333 22.6668V28.0002C25.333 28.7365 25.93 29.3335 26.6663 29.3335H29.333C30.0694 29.3335 30.6663 28.7365 30.6663 28.0002V22.6668C30.6663 21.9304 30.0694 21.3335 29.333 21.3335H26.6663Z"
          fill="url(#paint7_linear_1609_10673)"
        />
      </g>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9997 3.33341C23.9997 2.96522 24.2981 2.66675 24.6663 2.66675H27.9997C28.3679 2.66675 28.6663 2.96522 28.6663 3.33341V6.66675C28.6663 7.03494 28.3679 7.33341 27.9997 7.33341C27.6315 7.33341 27.333 7.03494 27.333 6.66675V4.94289L20.9425 11.3334C20.4218 11.8541 19.5776 11.8541 19.0569 11.3334L11.9997 4.27622L4.47108 11.8048C4.21073 12.0652 3.78862 12.0652 3.52827 11.8048C3.26792 11.5445 3.26792 11.1224 3.52827 10.862L11.0569 3.33341C11.5776 2.81272 12.4218 2.81272 12.9425 3.33341L19.9997 10.3906L26.3902 4.00008H24.6663C24.2981 4.00008 23.9997 3.7016 23.9997 3.33341Z"
          fill="url(#paint8_linear_1609_10673)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1609_10673"
          x1="5.99967"
          y1="23.3335"
          x2="1.99967"
          y2="23.3335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-8))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-4))" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1609_10673"
          x1="3.99967"
          y1="17.3335"
          x2="3.99967"
          y2="29.3335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-2))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-7))" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1609_10673"
          x1="13.9997"
          y1="19.3334"
          x2="9.92665"
          y2="19.3783"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-success-darken))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-success))" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1609_10673"
          x1="11.9997"
          y1="10.6667"
          x2="11.9997"
          y2="29.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-success))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-success))" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1609_10673"
          x1="21.9997"
          y1="22.0001"
          x2="17.9997"
          y2="22.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-8))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-4))" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1609_10673"
          x1="19.9997"
          y1="14.6667"
          x2="19.9997"
          y2="29.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-2))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-7))" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1609_10673"
          x1="29.9997"
          y1="25.3335"
          x2="25.9997"
          y2="25.3335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-8))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-4))" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1609_10673"
          x1="27.9997"
          y1="21.3335"
          x2="27.9997"
          y2="29.3335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-2))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-7))" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1609_10673"
          x1="3.66634"
          y1="12.0001"
          x2="21.262"
          y2="-4.99792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-success))" stopOpacity="0.36" />
          <stop offset="1" stopColor="rgb(var(--oui-color-success))" />
        </linearGradient>
      </defs>
    </svg>
  );
};
